<template>
  <!-- 商品分组 -->
  <div class="controlGroupInfo">
    <!-- 面包屑导航 -->
    <page-bar
      @back="goBack"
      @refresh="handleRefresh"
      :title="$route.meta.title"
    >
      <template slot="controls">
        <el-link
          icon="el-icon-question"
          type="primary"
          v-if="this.type == '客户组'"
          :href="baseUrl + '/UploadFile/Template/客户分组导入客户模板.xls'"
          target="_blank"
          >下载模板</el-link
        >
        <el-link
          icon="el-icon-question"
          type="primary"
          v-if="this.type == '商品组'"
          :href="baseUrl + '/UploadFile/Template/商品分组导入商品模板.xls'"
          target="_blank"
          >下载模板</el-link
        >
        <el-button
          type="primary"
          style="margin-left: 10px"
          icon="el-icon-folder-opened"
          @click="dropdownCommand"
          >导入</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="getDataList('')"
          >批量添加</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleDel('')"
          >批量删除</el-button
        >
      </template>
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          @keyup.enter.native="getTableData(1)"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="名称"
      >
      </el-table-column>
      <el-table-column
        prop="code"
        :label="codeName"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="des"
        label="描述"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <upload
      ref="upload"
      style="dispay: none"
      @fileChange="uploadGoods"
      :multiple="true"
    ></upload>
    <!-- 数据选择 -->
    <tableDialog
      v-if="dialogVisible"
      title="数据选择"
      :isMoreSel="true"
      :searchValue="searchData.name"
      :tableData="tableList"
      :tableHead="tableHead"
      :currPage.sync="currPageData"
      :pageSize.sync="pageSizeData"
      :allPage="allPageData"
      :layout="'total, prev, pager, next, jumper,sizes'"
      @search="getDataList"
      @moreSel="selDataOk"
      @rowClick="rowClick"
      @hanCurrChange="hanChangeData"
      @hanSizesChange="hanSizesChange"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
// import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "controlGroupInfo",
  data() {
    return {
      id: "",
      type: "",
      codeName: "编号",
      /**表格数据 */
      tableData: [],
      searchForm: {
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      // 数据选择
      dialogVisible: false,
      searchData: {
        name: "",
      },
      tableList: [],
      tableHead: {},
      currPageData: 1,
      pageSizeData: 10,
      allPageData: 0,
    };
  },
  mounted() {
    if (this.$route.query.prams) {
      let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
      if (prams) {
        this.id = prams.id;
        this.type = prams.type;
        switch (this.type) {
          case "商品组":
            this.codeName = "商品编号";
            break;
          case "客户组":
            this.codeName = "客户编号";
            break;
          case "区域组":
            this.codeName = "区域编号";
            break;
          case "企业组":
            this.codeName = "企业编号";
            break;
        }
        this.getTableData();
      }
    }
  },
  methods: {
    dropdownCommand() {
      this.$refs.upload.handleClick();
    },
    // 商品详情图片上传回调
    uploadGoods(file) {
      let url = "";
      if (this.type == "商品组") {
        url = "/Management/LimitsAdmin/ToExcelLimitsGoodsGroup";
      } else if (this.type == "客户组") {
        url = "/Management/LimitsAdmin/ToExcelLimitsMemberGroup";
      }
      file = file.slice(0, 200); //最多可选择200张，多余的将会截断
      if (file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("file", file[i]);
          fileData.append("code", this.id);
        }
        this.$uploadRequest({
          url: url,
          method: "post",
          data: fileData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            } else {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    updata() {
      if (this.id) {
        this.getTableData();
      }
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "ControlStatementsByPId",
        id: this.id,
        parameter: this.searchForm.name,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
        mold: this.type,
      };
      let proc = "Proc_OperationControl"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "brand/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = res.recordCount;
          if (res.flag == 0) {
            this.tableData = res.data.map((item) => ({
              id: item.Id,
              name: item.Name,
              code: item.Code,
              des: item.Describe,
              time: item.RecordTime,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },

    // 获取弹出框表格数据
    getDataList(val, isRep) {
      this.searchData.name = isRep ? val : this.searchData.name;
      let data = {
        type: "ControlStatementsSource",
        id: this.id,
        parameter: this.searchData.name,
        PageIndex: this.currPageData,
        PageSize: this.pageSizeData,
      };
      let proc = "Proc_OperationControl"; // 存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableList = res.content;
            this.tableHead = res.fdname;
            this.allPageData = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**当前页改变 */
    hanChangeData(val) {
      this.currPageData = val;
      this.getDataList();
    },
    /**当前页改变 */
    hanSizesChange(val) {
      this.pageSizeData = val;
      this.getDataList();
    },
    // 选择单条数据
    rowClick(row) {
      this.selDataOk([row]);
    },
    // 选择数据完成，多选
    selDataOk(selectedList) {
      if (selectedList.length == 0) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
        return;
      }
      let id = selectedList.map((item) => item.keyid).join(",");
      this.submit(id);
    },
    /**点击删除商品 */
    handleDel(id) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          id = id || this.selectedList.map((item) => item.id).join(",");
          let data = {
            type: "ControlStatementsDelete",
            list: id,
            id: this.id,
          };
          let proc = "Proc_OperationControl"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "ashx/MainReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    /**提交新增分类 */
    submit(id) {
      let data = {
        type: "ControlStatementsIncrease",
        list: id,
        id: this.id,
      };
      let proc = "Proc_OperationControl"; // 存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getTableData();
            // this.dialogVisible = false;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.controlGroupInfo {
  width: 100%;
  height: 100%;
}
</style>
